import * as R from 'ramda';
import { authenticatedApiFetch } from '../../common/helpers';
import { mapFiltersToJson, mapHistoryRowsFromJson } from './historyMappers';
import { mapLenderAccountFromJson } from '../account/accountMappers';
import { call, onSuccess } from 'actionware';
import { mapPaginatedResultFromJson } from '../../common/mappers';

const parseLenderAccounts = R.compose(
  R.map(mapLenderAccountFromJson),
  R.defaultTo([])
);
const parseTransactionHistory = mapPaginatedResultFromJson(
  mapHistoryRowsFromJson
);

export async function fetchLenderAccounts() {
  const result = await authenticatedApiFetch(`accounts`);
  return parseLenderAccounts(result);
}

export async function fetchTransactionHistory({ getState }) {
  const { history: { currentFilters, currentPage } } = getState();
  const result = await authenticatedApiFetch(`history`, 'get', {
    ...mapFiltersToJson(currentFilters),
    page: currentPage
  });
  return parseTransactionHistory(result);
}

export function updateFilters(type, value) {
  return {
    type,
    value
  };
}

export function changePage(currentPage) {
  return {
    currentPage
  };
}

// Side effects
// ------------------------------

onSuccess(updateFilters, () => {
  call(fetchTransactionHistory);
});

onSuccess(changePage, () => {
  call(fetchTransactionHistory);
});

onSuccess(fetchLenderAccounts, () => {
  call(fetchTransactionHistory);
});
